// extracted by mini-css-extract-plugin
export var addButton = "_n4-0";
export var border = "_n4-8";
export var check = "_n4-h";
export var danger = "_n4-6";
export var dropdownContainer = "_n4-1";
export var editModalBody = "_n4-j";
export var footerContainer = "_n4-i";
export var fullWidth = "_n4-a";
export var hide = "_n4-9";
export var icon = "_n4-3";
export var input = "_n4-7";
export var inputFlex = "_n4-b";
export var inputWrapper = "_n4-c";
export var manualFocus = "_n4-5";
export var optionButton = "_n4-4";
export var pillWrapper = "_n4-e";
export var pointer = "_n4-2";
export var showOverflow = "_n4-f";
export var tagsFlex = "_n4-d";
export var xButton = "_n4-g";